import {BAZA_URL} from './Kunteksto.js';

class Tekstoj
{
    constructor ()
    {
        this.tekstoj = new Map();
        this.ŝarĝita = false;
    }
    
    ŝarĝuTekstojn(lingvo, informilo)
    {
        //console.log ("ŝarĝuTekstojn (" + lingvo + ")");
        const  request = new XMLHttpRequest();
        const mi = this;
        const url = BAZA_URL + "tradukoj.php?LINGVO=" + (lingvo + 0);
        request.open('GET', url);
        request.onload = function ()
        {
            const data = JSON.parse (request.responseText);
            //console.log (request.responseText);
            mi.prilaboruRespondon (lingvo,data, informilo);
        };
        request.send();        
    }
    
    prilaboruRespondon (lingvo, data, informilo)
    {      
        this.tekstoj = new Map();
        
        for (var vico of data)
        {
            this.tekstoj.set (vico.kodo, vico.teksto);
        }
        this.ŝarĝita = true;
        informilo (lingvo);
    }
    
    teksto(ŝlosilo)
    {
        if (this.tekstoj.has(ŝlosilo))
        {
            return (this.tekstoj.get(ŝlosilo))
        } else
        {
            return ('**' + ŝlosilo + '**');
        }
    }
   
}
var TEKSTOJ = new Tekstoj();

export {TEKSTOJ};